import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import LoginPage from '../components/LoginPage';
import Spinner from '../components/Spinner';
import ErrorPage from '../errors/ErrorPage';

class Login extends Component {

  componentDidMount() {
    document.title = 'GALILEO - Login';
  }

  constructReturnUrls() {
    let successPath;
    try {
      successPath = this.props.location.state.from.pathname;
    } catch (e) {
        successPath = '/'
    }

    const { origin } = window.location;
    return `&failureRedirect=${origin}/login&successRedirect=${origin}${successPath}`;
  }

  render() {
    const redirectUrls = this.constructReturnUrls();
    const homeLocation = { from: { pathname: '/' } };
    const { from } = this.props.location.state || homeLocation;
    const { isLoggedIn, isFetching, error } = this.props;

    if (isFetching) {
      return <Spinner />
    }

    if (isLoggedIn) {
      return <Redirect to={from} />
    }

    return (
      <ErrorPage error={error} entity="login">
        <LoginPage redirectUrls={redirectUrls} />
      </ErrorPage>
    )
  }
}

const mapStateToProps = state => {
  const { user } = state;
  return {
    isFetching: user.isFetching,
    isLoggedIn: user.isLoggedIn,
    error: user.error
  }
}

export default connect(mapStateToProps)(Login);
